import styled from "styled-components";
import ChipGlowImg from "../../../assets/images/pluvaIonLanding/closing_chip_glow.png";
import { ionGradientText } from "../styles/ionGradientText";
import { useScrollReveal } from "../hooks/useScrollReveal";
import { revealDelayStyle } from "../styles/scrollReveal";

export const ClosingSection = () => {
  const helperTextReveal = useScrollReveal(0.3);
  const titleReveal = useScrollReveal(0.3);
  const imageReveal = useScrollReveal(0.3);

  return (
    <Container>
      <TextSection>
        <HelperTextWrapper ref={helperTextReveal.ref}>
          <HelperText 
            $visible={helperTextReveal.isVisible}
            $delay={0}
          >
            {"압도적 시야와 최첨단 지능의 결합"}
          </HelperText>
        </HelperTextWrapper>
        <TitleWrapper ref={titleReveal.ref}>
          <Title 
            $visible={titleReveal.isVisible}
            $delay={200}
          >
            {"플루바 아이온"}
          </Title>
        </TitleWrapper>
      </TextSection>

      <ImageWrapper ref={imageReveal.ref}>
        <ChipImage 
          src={ChipGlowImg} 
          alt="플루바 아이온" 
          loading="lazy"
          $visible={imageReveal.isVisible}
          $delay={400}
        />
      </ImageWrapper>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  align-self: stretch;

  padding-bottom: 64px;
  background-color: #000000;
`;

const TextSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;

  padding: 56px 24px 16px;
`;

const HelperTextWrapper = styled.div`
  width: 100%;
`;

const HelperText = styled.p<{ $visible: boolean; $delay: number }>`
  color: #ffffff;
  text-align: center;

  font-family: Pretendard;
  font-size: 20px;
  font-weight: 600;
  line-height: 130%;
  
  ${revealDelayStyle}
`;

const TitleWrapper = styled.div`
  width: 100%;
`;

const Title = styled.h2<{ $visible: boolean; $delay: number }>`
  text-align: center;

  font-family: Pretendard;
  font-size: clamp(35px, 7vw, 42px);
  font-weight: 700;
  line-height: 130%;

  ${ionGradientText}
  ${revealDelayStyle}
`;

const ImageWrapper = styled.div`
  width: 100%;
`;

const ChipImage = styled.img<{ $visible: boolean; $delay: number }>`
  width: 100%;
  display: block;
  object-fit: cover;
  
  ${revealDelayStyle}
`;
